// Auth Data

export default {
  name: {
    label: 'Поиск по названию',
    value: '',
    type: 'text',
    error: null,
    min: 1,
    max: 30,
    req: /[A-Za-zА-Яа-я0-9]/,
    validate: false
  },
  priceFrom: {
    label: 'Стоимость от',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: false
  },
  priceTo: {
    label: 'Стоимость до',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: false
  },
  category: {
    label: 'Категория',
    placeholder: 'Выберите значение',
    value: '',
    type: 'select',
    items: [
      { value: 0, name: 'Не указывать' },
      { value: 1, name: 'Море' },
      { value: 2, name: 'Природа' },
      { value: 3, name: 'Города' },
      { value: 3, name: 'Из Москвы' }
    ],
    error: null,
    min: null,
    max: null,
    req: null,
    required: false,
    validate: false
  },
  sort: {
    label: 'Сортировать по',
    placeholder: 'Выберите значение',
    value: '',
    type: 'select',
    items: [
      { value: 0, name: 'Не сортировать' },
      { value: 1, name: 'Имени' },
      { value: 2, name: 'Стоимости' },
      { value: 3, name: 'Дате' },
      { value: 4, name: 'Гайд дня' }
    ],
    error: null,
    min: null,
    max: null,
    req: null,
    required: false,
    validate: false
  }
}
